module.exports = __webpack_public_path__ + "img/AlSalam2.24514ccc.jpg";